import { ArrowDownOutlined, ArrowUpOutlined, FallOutlined, ReloadOutlined, RiseOutlined } from "@ant-design/icons";
import { ResponsiveBar } from "@nivo/bar";
import { Col, message, Row, Spin, Table, Tabs, Tooltip } from "antd";
import axios from "axios";
import moment from "moment";
import React, { Component } from "react";
import { connect } from "react-redux";
import { ButtonItem, TagItem } from "../../../../Components/Items";
import { colorPaleta } from "../../../../Components/TagItem";
import SegmentedItem from "../../../../Components/SegmentedItem";
import { ChartCard, EstadoVacio, HeaderReporte, KpiRow, NIVO_THEME, STYLES } from "../../../Panel/Calidad/ReporteCalidad/reporteCalidadStyles";
import { formatoDinero, postCobro } from "./cobroBiwoTextos";

const COLOR = colorPaleta("cyan");
const VERDE = colorPaleta("verdeNatural");
const ROJO = colorPaleta("danger");
const opcionesFiltro = (filas, campo) => [...new Set((filas || []).map((f) => f[campo]).filter(Boolean))].map((v) => ({ text: v, value: v }));
const plural = (n, uno, varios) => `${n} ${n === 1 ? uno : varios}`;
const dineroCorto = (valor) => (Math.abs(valor) >= 1000 ? `$${(valor / 1000).toFixed(valor >= 10000 ? 0 : 1)}k` : `$${Math.round(valor)}`);
const conSigno = (valor) => `${valor > 0 ? "+" : valor < 0 ? "−" : ""}${formatoDinero(Math.abs(valor))}`;

const Seccion = ({ titulo, detalle, children }) => (
    <div style={{ marginBottom: 18 }}>
        <div style={{ fontWeight: 700, color: "#1e293b", fontSize: 14 }}>{titulo}</div>
        {detalle && <div style={{ fontSize: 12, color: "#64748b", marginBottom: 8 }}>{detalle}</div>}
        {children}
    </div>
);

class ResumenCobro extends Component {
    state = { loading: true, datos: null, ordenModulos: "ingreso", verModulos: "contratados" };

    componentDidMount() {
        this.consultar();
    }

    consultar = () => {
        this.setState({ loading: true });
        postCobro(axios, "selectResumenCobro", {}, this.props.headersToken).then((data) => {
            if (data.success === 2) this.setState({ loading: false, datos: data.data });
            else {
                this.setState({ loading: false });
                message.error(data.message || "No se pudo consultar el resumen");
            }
        });
    };

    renderKpis() {
        const { kpis, descuentos } = this.state.datos;
        const cambio = kpis.ingresoMesPasado > 0 ? ((kpis.ingresoMensual - kpis.ingresoMesPasado) / kpis.ingresoMesPasado) * 100 : null;
        return (
            <KpiRow
                items={[
                    {
                        key: "ingreso",
                        label: "Ingreso mensual",
                        value: formatoDinero(kpis.ingresoMensual),
                        color: COLOR,
                        span: 6,
                        hint: cambio === null ? "Sin planes el mes pasado para comparar" : `${cambio >= 0 ? "▲" : "▼"} ${Math.abs(cambio).toFixed(1)}% contra el mes pasado (${formatoDinero(kpis.ingresoMesPasado)})`,
                    },
                    { key: "clientes", label: "Clientes que pagan", value: kpis.clientes, color: "#1e293b", span: 4, hint: plural(kpis.empresas, "empresa con plan", "empresas con plan") },
                    { key: "ticket", label: "Pago promedio por cliente", value: formatoDinero(kpis.ticketPromedio), color: "#1e293b", span: 5, hint: "Al mes" },
                    {
                        key: "descuentos",
                        label: "Descuentos que damos",
                        value: formatoDinero(descuentos.total),
                        color: descuentos.total > 0 ? colorPaleta("naranjaOscuro") : "#1e293b",
                        span: 5,
                        hint: descuentos.total > 0 ? `Combos ${formatoDinero(descuentos.combos)} · precios especiales ${formatoDinero(descuentos.especiales)}` : "Hoy todos pagan precio de lista",
                    },
                    { key: "lista", label: "A precio de lista sería", value: formatoDinero(kpis.ingresoLista), color: "#64748b", span: 4, hint: "Sin combos ni descuentos" },
                ]}
            />
        );
    }

    renderModulos() {
        const { modulos } = this.state.datos;
        const porEmpresas = this.state.ordenModulos === "empresas";
        const contratado = (m) => m.ingreso > 0 || m.empresas > 0 || m.clientes > 0;
        const contratados = modulos.filter(contratado).length;
        const todos = this.state.verModulos === "todos";
        const lista = [...modulos].filter((m) => (porEmpresas ? m.empresas !== null : true) && (todos || contratado(m))).sort((a, b) => (porEmpresas ? (b.empresas || 0) - (a.empresas || 0) || b.ingreso - a.ingreso : b.ingreso - a.ingreso));
        const maximo = Math.max(1, ...lista.map((m) => (porEmpresas ? m.empresas || 0 : m.ingreso)));
        return (
            <ChartCard label="Módulos" titulo={porEmpresas ? "¿Qué módulo es el más contratado?" : "¿Qué módulo deja más dinero?"} altura="auto">
                <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginBottom: 14 }}>
                    <SegmentedItem
                        value={this.state.ordenModulos}
                        onChange={(valor) => this.setState({ ordenModulos: valor })}
                        options={[{ value: "ingreso", label: "Por dinero al mes" }, { value: "empresas", label: "Por empresas que lo tienen" }]}
                        style={{ maxWidth: "100%" }}
                    />
                    <SegmentedItem
                        value={this.state.verModulos}
                        onChange={(valor) => this.setState({ verModulos: valor })}
                        options={[{ value: "contratados", label: `Contratados (${contratados})` }, { value: "todos", label: `Todos (${modulos.length})` }]}
                        style={{ maxWidth: "100%" }}
                    />
                </div>
                {lista.length === 0 && <EstadoVacio titulo="Sin módulos contratados" texto="Cuando las empresas contraten módulos aparecerán aquí." />}
                {lista.map((m, i) => {
                    const valor = porEmpresas ? m.empresas || 0 : m.ingreso;
                    const vacio = !contratado(m);
                    return (
                        <div key={m.clave} style={{ display: "grid", gridTemplateColumns: "18px minmax(0, 1.3fr) minmax(40px, 2fr) auto", alignItems: "center", columnGap: 10, marginBottom: 10, opacity: vacio ? 0.55 : 1 }}>
                            <span style={{ color: "#94a3b8", fontWeight: 700, fontSize: 12 }}>{i + 1}</span>
                            <div>
                                <div style={{ fontWeight: 600, color: "#1e293b", lineHeight: 1.2 }}>{m.nombre}</div>
                                <div style={{ fontSize: 11.5, color: "#64748b" }}>
                                    {vacio ? "Nadie lo tiene todavía" : m.empresas === null ? `Cobro general · ${plural(m.clientes, "cliente", "clientes")}` : `${m.empresas} de ${this.state.datos.kpis.empresas} empresas (${m.adopcion}%)`}
                                </div>
                            </div>
                            <Tooltip
                                title={
                                    <>
                                        <div>{formatoDinero(m.ingreso)} al mes</div>
                                        {m.enCombo > 0 && <div>{formatoDinero(m.enCombo)} viene de combos</div>}
                                        {m.excedente > 0 && <div>{formatoDinero(m.excedente)} por empleados adicionales</div>}
                                    </>
                                }
                            >
                                <div style={{ height: 12, background: "#f1f5f9", borderRadius: 4 }}>
                                    <div style={{ width: valor > 0 ? `${Math.max(2, (valor / maximo) * 100)}%` : 0, height: "100%", background: COLOR, borderRadius: 4 }} />
                                </div>
                            </Tooltip>
                            <div style={{ textAlign: "right", fontWeight: 700, color: "#1e293b", whiteSpace: "nowrap" }}>
                                {porEmpresas ? plural(valor, "empresa", "empresas") : formatoDinero(valor)}
                            </div>
                        </div>
                    );
                })}
            </ChartCard>
        );
    }

    renderTendencia() {
        const { tendencia } = this.state.datos;
        const hayDatos = tendencia.some((m) => m.cobrado > 0);
        return (
            <ChartCard label="Últimos 12 meses" titulo="Lo que se ha cobrado cada mes" pill="Sin IVA" altura={300}>
                {!hayDatos ? (
                    <EstadoVacio titulo="Todavía no hay cobros" texto="Aquí se verá lo que se cobra en cada corte." />
                ) : (
                    <ResponsiveBar
                        data={tendencia.map((m) => ({ mes: m.etiqueta, Cobrado: m.cobrado, enCurso: m.enCurso }))}
                        keys={["Cobrado"]}
                        indexBy="mes"
                        margin={{ top: 16, right: 8, bottom: 32, left: 52 }}
                        padding={0.35}
                        colors={(barra) => (barra.data.enCurso ? `${COLOR}80` : COLOR)}
                        borderRadius={4}
                        axisTop={null}
                        axisRight={null}
                        axisBottom={{ tickSize: 0, tickPadding: 8 }}
                        axisLeft={{ tickSize: 0, tickPadding: 6, tickValues: 4, format: dineroCorto }}
                        enableGridX={false}
                        gridYValues={4}
                        enableLabel={false}
                        theme={NIVO_THEME}
                        tooltip={({ data }) => (
                            <div style={{ background: "#fff", padding: "8px 12px", border: "1px solid #e2e8f0", borderRadius: 8, fontSize: 12 }}>
                                <b>{data.mes}</b>
                                <div>{formatoDinero(data.Cobrado)}</div>
                                {data.enCurso && <div style={{ color: "#64748b" }}>Mes en curso</div>}
                            </div>
                        )}
                    />
                )}
            </ChartCard>
        );
    }

    renderMovimientos() {
        const { movimientos } = this.state.datos;
        const { totales } = movimientos;
        const tarjetas = [
            { key: "altas", titulo: "Módulos nuevos", icono: <ArrowUpOutlined />, color: VERDE, ...totales.altas, extra: totales.altas.porCliente ? `${totales.altas.porCliente} los contrató el cliente solo` : null },
            { key: "subidas", titulo: "Subieron de paquete", icono: <RiseOutlined />, color: VERDE, ...totales.subidas },
            { key: "bajadas", titulo: "Bajaron de paquete", icono: <FallOutlined />, color: ROJO, ...totales.bajadas },
            { key: "bajas", titulo: "Dados de baja", icono: <ArrowDownOutlined />, color: ROJO, ...totales.bajas },
        ];
        const columnas = (conDesde, filas) => [
            { title: "Empresa", render: (m) => <><div>{m.empresa}</div><div style={{ fontSize: 11.5, color: "#94a3b8" }}>{m.master}</div></>, filters: opcionesFiltro(filas, "empresa"), onFilter: (valor, m) => m.empresa === valor },
            { title: "Módulo", render: (m) => (conDesde ? `${m.modulo}: ${m.desde} → ${m.paquete}` : [m.modulo, m.paquete].filter(Boolean).join(" · ")), filters: opcionesFiltro(filas, "modulo"), onFilter: (valor, m) => m.modulo === valor },
            { title: "Fecha", render: (m) => moment(m.fecha).format("DD/MM/YYYY"), sorter: (a, b) => moment(a.fecha).valueOf() - moment(b.fecha).valueOf() },
            { title: "Al mes", align: "right", render: (m) => <span style={{ color: m.monto >= 0 ? VERDE : ROJO, fontWeight: 600 }}>{conSigno(m.monto)}</span>, sorter: (a, b) => (a.monto || 0) - (b.monto || 0) },
        ];
        const lista = (clave) => movimientos[clave];
        return (
            <ChartCard label={moment().format("MMMM YYYY")} titulo="Movimiento del mes" pill={`Neto ${conSigno(movimientos.neto)} al mes`} altura="auto">
                <Row gutter={[12, 12]} style={{ marginBottom: 12 }}>
                    {tarjetas.map((t) => (
                        <Col key={t.key} xs={12} md={6}>
                            <div style={{ border: "1px solid #e2e8f0", borderRadius: 10, padding: "10px 14px" }}>
                                <div style={{ color: "#64748b", fontSize: 12 }}>
                                    <span style={{ color: t.color, marginRight: 6 }}>{t.icono}</span>
                                    {t.titulo}
                                </div>
                                <div style={{ fontSize: 22, fontWeight: 700, color: "#1e293b" }}>{t.cantidad}</div>
                                <div style={{ fontSize: 12, color: t.cantidad ? t.color : "#94a3b8", fontWeight: 600 }}>{t.cantidad ? `${conSigno(t.monto)} al mes` : "—"}</div>
                                {t.extra && <div style={{ fontSize: 11.5, color: "#64748b" }}>{t.extra}</div>}
                            </div>
                        </Col>
                    ))}
                </Row>
                <Tabs size="small">
                    <Tabs.TabPane key="altas" tab={`Nuevos (${totales.altas.cantidad})`}>
                        <Table size="small" scroll={{ x: "max-content" }} rowKey={(m, i) => i} pagination={{ pageSize: 8 }} dataSource={lista("altas")} columns={[...columnas(false, lista("altas")).slice(0, 3), { title: "", render: (m) => (m.porCliente ? <TagItem cyan>Lo contrató el cliente</TagItem> : null), filters: [{ text: "Lo contrató el cliente", value: "cliente" }, { text: "Lo contratamos nosotros", value: "biwo" }], onFilter: (valor, m) => (m.porCliente ? "cliente" : "biwo") === valor }, columnas(false, lista("altas"))[3]]} />
                    </Tabs.TabPane>
                    <Tabs.TabPane key="subidas" tab={`Subieron (${totales.subidas.cantidad})`}>
                        <Table size="small" scroll={{ x: "max-content" }} rowKey={(m, i) => i} pagination={{ pageSize: 8 }} dataSource={lista("subidas")} columns={columnas(true, lista("subidas"))} />
                    </Tabs.TabPane>
                    <Tabs.TabPane key="bajadas" tab={`Bajaron (${totales.bajadas.cantidad})`}>
                        <Table size="small" scroll={{ x: "max-content" }} rowKey={(m, i) => i} pagination={{ pageSize: 8 }} dataSource={lista("bajadas")} columns={columnas(true, lista("bajadas"))} />
                    </Tabs.TabPane>
                    <Tabs.TabPane key="bajas" tab={`Bajas (${totales.bajas.cantidad})`}>
                        <Table size="small" scroll={{ x: "max-content" }} rowKey={(m, i) => i} pagination={{ pageSize: 8 }} dataSource={lista("bajas")} columns={columnas(false, lista("bajas"))} />
                    </Tabs.TabPane>
                </Tabs>
            </ChartCard>
        );
    }

    renderOportunidades() {
        const { cercaLimite, excedentes, sinModulo } = this.state.datos.oportunidades;
        const extraExcedentes = excedentes.reduce((s, e) => s + e.excedenteMensual, 0);
        const ganancia = excedentes.filter((e) => e.paqueteSiguiente && !e.conviene).reduce((s, e) => s + (e.diferencia - e.excedenteMensual), 0);
        const vacio = !cercaLimite.length && !excedentes.length && !sinModulo.length;
        const empresa = (m) => <><div>{m.empresa}</div><div style={{ fontSize: 11.5, color: "#94a3b8" }}>{m.master}</div></>;
        return (
            <ChartCard label="Dinero por ganar" titulo="Oportunidades de venta" pill={`${plural(cercaLimite.length + excedentes.length, "empresa", "empresas")} para subir de paquete`} altura="auto">
                {vacio && <EstadoVacio titulo="Sin oportunidades por ahora" texto="Aquí aparecen las empresas que ya casi llenan su paquete o que pagan de más." />}
                {excedentes.length > 0 && (
                    <Seccion
                        titulo="Pagan empleados adicionales"
                        detalle={`Están pasados de su paquete y nos dejan ${formatoDinero(extraExcedentes)} extra al mes por empleados de más.`}
                    >
                        <Table
                            size="small"
                            scroll={{ x: "max-content" }}
                            rowKey={(m, i) => i}
                            pagination={{ pageSize: 5 }}
                            dataSource={excedentes}
                            columns={[
                                { title: "Empresa", render: empresa, filters: opcionesFiltro(excedentes, "empresa"), onFilter: (valor, m) => m.empresa === valor },
                                { title: "Módulo", render: (m) => `${m.modulo} · ${m.paquete}`, filters: opcionesFiltro(excedentes, "modulo"), onFilter: (valor, m) => m.modulo === valor },
                                { title: "Empleados de más", align: "center", dataIndex: "adicionales", sorter: (a, b) => (a.adicionales || 0) - (b.adicionales || 0) },
                                { title: "Paga extra al mes", align: "right", render: (m) => formatoDinero(m.excedenteMensual), sorter: (a, b) => (a.excedenteMensual || 0) - (b.excedenteMensual || 0) },
                                { title: "Paquete siguiente", render: (m) => (m.paqueteSiguiente ? `${m.paqueteSiguiente} (+${formatoDinero(m.diferencia)})` : "Ya está en el más alto"), sorter: (a, b) => (a.diferencia || 0) - (b.diferencia || 0) },
                                {
                                    title: "",
                                    filters: [
                                        { text: "Al cliente le conviene subir", value: "conviene" },
                                        { text: "Si sube ganamos", value: "ganamos" },
                                        { text: "Ya está en el más alto", value: "tope" },
                                    ],
                                    onFilter: (valor, m) => (!m.paqueteSiguiente ? "tope" : m.conviene ? "conviene" : "ganamos") === valor,
                                    render: (m) =>
                                        !m.paqueteSiguiente ? null : m.conviene ? (
                                            <Tooltip title="Pagaría menos con el paquete de arriba: ofrécelo para cuidar al cliente">
                                                <TagItem azul>Al cliente le conviene subir · ahorra {formatoDinero(m.excedenteMensual - m.diferencia)}</TagItem>
                                            </Tooltip>
                                        ) : (
                                            <TagItem verdeNatural>Si sube ganamos +{formatoDinero(m.diferencia - m.excedenteMensual)}</TagItem>
                                        ),
                                },
                            ]}
                        />
                        {ganancia > 0 && <div style={{ fontSize: 12, color: VERDE, fontWeight: 600 }}>Si los que pueden suben de paquete, ganamos {formatoDinero(ganancia)} más al mes.</div>}
                    </Seccion>
                )}
                {cercaLimite.length > 0 && (
                    <Seccion titulo="Están por llenar su paquete" detalle="Ya usan el 80% o más de lo que incluye su paquete.">
                        <Table
                            size="small"
                            scroll={{ x: "max-content" }}
                            rowKey={(m, i) => i}
                            pagination={{ pageSize: 5 }}
                            dataSource={cercaLimite}
                            columns={[
                                { title: "Empresa", render: empresa, filters: opcionesFiltro(cercaLimite, "empresa"), onFilter: (valor, m) => m.empresa === valor },
                                { title: "Módulo", render: (m) => `${m.modulo} · ${m.paquete}`, filters: opcionesFiltro(cercaLimite, "modulo"), onFilter: (valor, m) => m.modulo === valor },
                                {
                                    title: "Uso",
                                    sorter: (a, b) => (a.porcentaje || 0) - (b.porcentaje || 0),
                                    render: (m) => (
                                        <div style={{ minWidth: 160 }}>
                                            <div style={{ fontSize: 12 }}>{`${m.usados} de ${m.limite} ${m.unidad}`}</div>
                                            <div style={{ height: 8, background: "#f1f5f9", borderRadius: 4 }}>
                                                <div style={{ width: `${Math.min(100, m.porcentaje)}%`, height: "100%", borderRadius: 4, background: m.porcentaje >= 100 ? ROJO : colorPaleta("ambar") }} />
                                            </div>
                                        </div>
                                    ),
                                },
                                { title: "Paquete siguiente", render: (m) => (m.paqueteSiguiente ? `${m.paqueteSiguiente} (+${formatoDinero(m.diferencia)} al mes)` : "Ya está en el más alto"), sorter: (a, b) => (a.diferencia || 0) - (b.diferencia || 0) },
                            ]}
                        />
                    </Seccion>
                )}
                {sinModulo.length > 0 && (
                    <Seccion titulo="Lo que casi todos tienen y ellos no" detalle="Módulos populares que a estas empresas todavía no les hemos vendido.">
                        <Row gutter={[12, 12]}>
                            {sinModulo.map((m) => (
                                <Col key={m.clave} xs={24} md={12} xl={8}>
                                    <div style={{ border: "1px solid #e2e8f0", borderRadius: 10, padding: "10px 14px", height: "100%" }}>
                                        <div style={{ fontWeight: 700, color: "#1e293b" }}>{m.modulo}</div>
                                        <div style={{ fontSize: 12, color: "#64748b", marginBottom: 6 }}>
                                            Lo tiene el {m.adopcion}% · faltan {plural(m.faltan, "empresa", "empresas")}
                                            {m.precio > 0 ? ` · desde ${formatoDinero(m.precio)} al mes` : ""}
                                        </div>
                                        {m.empresas.map((e, i) => (
                                            <div key={i} style={{ fontSize: 12.5 }}>
                                                {e.nombre} <span style={{ color: "#94a3b8" }}>· {e.master}</span>
                                            </div>
                                        ))}
                                        {m.faltan > m.empresas.length && <div style={{ fontSize: 12, color: "#94a3b8" }}>y {m.faltan - m.empresas.length} más</div>}
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    </Seccion>
                )}
            </ChartCard>
        );
    }

    renderTopClientes() {
        const { topClientes } = this.state.datos;
        const maximo = Math.max(1, ...topClientes.map((c) => c.ingreso));
        return (
            <ChartCard label="Clientes" titulo="Los 10 que más pagan" altura="auto">
                {topClientes.length === 0 ? (
                    <EstadoVacio titulo="Sin clientes con plan" texto="Configura el cobro de un master para verlo aquí." />
                ) : (
                    <Table
                        size="small"
                        scroll={{ x: "max-content" }}
                        rowKey="_id"
                        pagination={false}
                        dataSource={topClientes}
                        columns={[
                            { title: "#", width: 36, render: (c, r, i) => <span style={{ color: "#94a3b8", fontWeight: 700 }}>{i + 1}</span> },
                            { title: "Cliente", render: (c) => <><div style={{ fontWeight: 600 }}>{c.nombre}</div>{c.corporativo && <div style={{ fontSize: 11.5, color: "#94a3b8" }}>{c.corporativo}</div>}</>, filters: opcionesFiltro(topClientes, "nombre"), onFilter: (valor, c) => c.nombre === valor },
                            { title: "Empresas", align: "center", dataIndex: "empresas", sorter: (a, b) => (a.empresas || 0) - (b.empresas || 0) },
                            { title: "Módulos", align: "center", dataIndex: "modulos", sorter: (a, b) => (a.modulos || 0) - (b.modulos || 0) },
                            {
                                title: "Paga al mes",
                                align: "right",
                                sorter: (a, b) => (a.ingreso || 0) - (b.ingreso || 0),
                                render: (c) => (
                                    <div style={{ display: "flex", alignItems: "center", gap: 10, justifyContent: "flex-end", whiteSpace: "nowrap" }}>
                                        <div style={{ width: 90, height: 8, background: "#f1f5f9", borderRadius: 4 }}>
                                            <div style={{ width: `${(c.ingreso / maximo) * 100}%`, height: "100%", background: COLOR, borderRadius: 4 }} />
                                        </div>
                                        <b style={{ minWidth: 90 }}>{formatoDinero(c.ingreso)}</b>
                                    </div>
                                ),
                            },
                        ]}
                    />
                )}
            </ChartCard>
        );
    }

    render() {
        const { datos, loading } = this.state;
        return (
            <div style={{ background: "#f8fafc", padding: 16, borderRadius: 12 }}>
                <style>{STYLES}</style>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 12 }}>
                    <HeaderReporte eyebrow="Resumen del negocio" titulo="¿Cómo va el plan BIWO?" subtitulo="Montos sin IVA y al mes, con los planes activos de hoy." />
                    <Tooltip title="Actualizar">
                        <ButtonItem type="text" icon={<ReloadOutlined />} onClick={this.consultar} />
                    </Tooltip>
                </div>
                <Spin spinning={loading}>
                    {!datos ? (
                        <div style={{ minHeight: 300 }} />
                    ) : (
                        <>
                            {this.renderKpis()}
                            <Row gutter={[16, 16]}>
                                <Col xs={24} xl={13}>{this.renderModulos()}</Col>
                                <Col xs={24} xl={11}>{this.renderTendencia()}</Col>
                                <Col xs={24}>{this.renderOportunidades()}</Col>
                                <Col xs={24}>{this.renderMovimientos()}</Col>
                                <Col xs={24}>{this.renderTopClientes()}</Col>
                            </Row>
                        </>
                    )}
                </Spin>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({ headersToken: state.user.headersToken });

export default connect(mapStateToProps)(ResumenCobro);
